module.exports = __webpack_public_path__ + "static/lahli_spinach_rustica_bites2_554x462-6177032577db40771a7baa78935cb586.png";